import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getHeaderData = createAsyncThunk('headerData/getHeaderData', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getHeader();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
